export let emptyStateMessageSelectAnItemToRead = "AXocsc";
export default {emptyStateMessageSelectAnItemToRead};